import NextLink from "next/link";
import NewLocationIcon from "components/icons-svg/NewLocationIcon";
import useRecentlySearches from "hooks/swr/useRecentlySearches";
import { getFormattedDate } from "utils/dates";
import { formatDateRange } from "utils/helper";
import { createSearchURL, getRecentSearchParams } from "utils/url";
const SearchPlaceSuggestions = ({
  fromModal = false,
  variant = "default"
}: {
  fromModal?: boolean;
  variant?: string;
}) => {
  const {
    recentlySearches: recentSearchesData
  } = useRecentlySearches();
  const recentSearches = recentSearchesData || [];
  if (recentSearches.length === 0) {
    return null;
  }
  return <main className={`overflow-hidden rounded-[10px] ${variant === "homeNew" ? `p-2` : ""} ${fromModal ? "" : "border-[1px] border-[#CCC9C9] bg-white"}`} data-sentry-component="SearchPlaceSuggestions" data-sentry-source-file="SearchPlaceSuggestions.tsx">
      {variant === "homeNew" && <p className='px-4 py-2 text-xs font-semibold leading-3 text-[#707281]'>
          Previous searches
        </p>}
      <div className='w-full'>
        {recentSearches.map((item, index) => {
        const {
          searchStartDate,
          searchEndDate
        } = getFormattedDate(item?.checkInDate || "", item?.checkOutDate || "");
        return <NextLink href={`/vacation-rentals/${createSearchURL(item.name)}${getRecentSearchParams(item)}`} passHref key={`${item.placeId}-${item.checkInDate || ""}-${item.checkOutDate || ""}-${index}`}>
              <div className={`${variant === "homeNew" ? "rounded-[8px] p-4 hover:bg-[#E1E3EC]" : "p-2 hover:bg-[#F8F8F8] "}`} role='button' tabIndex={0}>
                {variant === "homeNew" ? <div className='flex w-full cursor-pointer items-center justify-between gap-3'>
                    <p className='max-w-[200px] truncate text-sm font-semibold leading-[14px] text-[#000]'>
                      {item.name}
                    </p>
                    {item.checkInDate && new Date(item.checkInDate) >= new Date() && <p className='whitespace-nowrap text-sm font-semibold leading-[14px] text-[#707281]'>
                          {formatDateRange(searchStartDate, searchEndDate)}
                        </p>}
                  </div> : <div className='flex w-full cursor-pointer items-center justify-between gap-3'>
                    <div className='flex w-full items-start gap-2'>
                      <div className='block'>
                        <NewLocationIcon className='text-[#8D91A5]' />
                      </div>
                      {/* <div className='hidden lg:block'>
                        <div className='flex h-[19px] w-[19px] items-center justify-center rounded-full bg-[#E6F9F9]'>
                          <LocationIcon className='h-5 w-5 text-[#8D8A8A]' />
                        </div>
                       </div> */}
                      <div className='flex flex-col'>
                        <p className='whitespace-pre-wrap text-start text-sm font-medium leading-[14px] text-[#707281] lg:leading-none lg:text-[#7C7676]'>
                          {item.name}
                        </p>
                        {item.checkInDate && new Date(item.checkInDate) >= new Date() && <p className='mt-1 max-w-[300px] whitespace-pre-wrap text-start text-xs font-normal text-[#707281] lg:text-[#8D8A8A]'>
                              {formatDateRange(searchStartDate, searchEndDate)}
                            </p>}
                      </div>
                    </div>
                  </div>}
              </div>
            </NextLink>;
      })}
      </div>
    </main>;
};
export default SearchPlaceSuggestions;